import styled from "styled-components/macro";

const BodyPage = styled.div`
    padding: 24px;
    max-height: calc(100vh - 52px - 48px );
`;

export default BodyPage;
